import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { drEventTaxonomyReferenceDataProxyApiRef, DrEventTaxonomyReferenceDataClient } from './api';

export const drEventTaxonomyReferenceDataPlugin = createPlugin({
  id: 'dr-event-taxonomy-reference-data',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: drEventTaxonomyReferenceDataProxyApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory(deps) {
        return new DrEventTaxonomyReferenceDataClient(deps);
      },
    }),
  ],
});

export const DrEventTaxonomyReferenceDataPage = drEventTaxonomyReferenceDataPlugin.provide(
  createRoutableExtension({
    name: 'DrEventTaxonomyReferenceDataPage',
    component: () => import('./components/Events').then(m => m.HomeComponent),
    mountPoint: rootRouteRef,
  }),
);
